import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginForm from './components/auth/LoginForm';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import PropertiesList from './components/properties/PropertiesList';
import PropertyDetail from './components/properties/PropertyDetail';
import SourcesList from './components/sources/SourcesList';
import SourceDetail from './components/sources/SourceDetail';
import { SystemLogsPage } from './components/SystemLogsPage';
import { Outlet } from 'react-router-dom';

// Layout wrapper component
const LayoutWrapper = () => (
  <Layout>
    <Outlet />
  </Layout>
);

// Protected routes component
const ProtectedRoutes = () => {
  const { isAuthenticated, loading } = useAuth();

  // Don't render anything while checking authentication status
  if (loading) {
    return null; // The loading state is handled in AuthContext
  }

  if (!isAuthenticated) {
    return <LoginForm />;
  }

  return (
    <Routes>
      <Route path="/" element={<LayoutWrapper />}>
        <Route index element={<Dashboard />} />
        <Route path="properties" element={<PropertiesList />} />
        <Route path="sources/:sourceId/properties/:id" element={<PropertyDetail />} />
        <Route path="sources" element={<SourcesList />} />
        <Route path="sources/:id" element={<SourceDetail />} />
        <Route path="system-logs" element={<SystemLogsPage />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ProtectedRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;